module.exports = __webpack_public_path__ + "img/sa-20-league-2024-logo-default.d5725e56.png";